const getHouseholdRelationships = (postData) => {
  let resp = {
    success: true,
    userID: 22,
    householdRelationships: [
      {
        relationshipTypeData: {
          typeID: 3,
          name: "child",
          status: 1,
        },
        similarRelationships: [
          {
            typeID: 3,
            name: "child",
          },
          {
            typeID: 5,
            name: "grandchild",
          },
          {
            typeID: 8,
            name: "step-child",
          },
          {
            typeID: 10,
            name: "niece/nephew",
          },
          {
            typeID: 12,
            name: "child-in-law",
          },
          {
            typeID: 2,
            name: "parent",
          },
          {
            typeID: 4,
            name: "grandparent",
          },
          {
            typeID: 6,
            name: "sibling",
          },
          {
            typeID: 7,
            name: "step-parent",
          },
          {
            typeID: 9,
            name: "aunt/uncle",
          },
          {
            typeID: 11,
            name: "parent-in-law",
          },
          {
            typeID: 13,
            name: "cousin",
          },
          {
            typeID: 15,
            name: "friend",
          },
          {
            typeID: 16,
            name: "other",
          },
        ],
        relativeUserID: 132,
        relativeUserFname: "Super",
        relativeUserLname: "Admin",
        relativeUserPhotoURL:
          "https://dhdj1c2suf90g.cloudfront.net/images/nophoto.jpg",
      },
      {
        relationshipTypeData: {
          typeID: 3,
          name: "child",
          status: 1,
        },
        similarRelationships: [
          {
            typeID: 3,
            name: "child",
          },
          {
            typeID: 5,
            name: "grandchild",
          },
          {
            typeID: 8,
            name: "step-child",
          },
          {
            typeID: 10,
            name: "niece/nephew",
          },
          {
            typeID: 12,
            name: "child-in-law",
          },
          {
            typeID: 2,
            name: "parent",
          },
          {
            typeID: 4,
            name: "grandparent",
          },
          {
            typeID: 6,
            name: "sibling",
          },
          {
            typeID: 7,
            name: "step-parent",
          },
          {
            typeID: 9,
            name: "aunt/uncle",
          },
          {
            typeID: 11,
            name: "parent-in-law",
          },
          {
            typeID: 13,
            name: "cousin",
          },
          {
            typeID: 15,
            name: "friend",
          },
          {
            typeID: 16,
            name: "other",
          },
        ],
        relativeUserID: 133,
        relativeUserFname: "Wifey",
        relativeUserLname: "Admin",
        relativeUserPhotoURL:
          "https://dhdj1c2suf90g.cloudfront.net/images/nophoto.jpg",
      },
      {
        relationshipTypeData: {
          typeID: 10,
          name: "niece/nephew",
          status: 1,
        },
        similarRelationships: [
          {
            typeID: 10,
            name: "niece/nephew",
          },
          {
            typeID: 8,
            name: "step-child",
          },
          {
            typeID: 12,
            name: "child-in-law",
          },
          {
            typeID: 13,
            name: "cousin",
          },
          {
            typeID: 5,
            name: "grandchild",
          },
          {
            typeID: 2,
            name: "parent",
          },
          {
            typeID: 4,
            name: "grandparent",
          },
          {
            typeID: 6,
            name: "sibling",
          },
          {
            typeID: 7,
            name: "step-parent",
          },
          {
            typeID: 9,
            name: "aunt/uncle",
          },
          {
            typeID: 11,
            name: "parent-in-law",
          },
          {
            typeID: 15,
            name: "friend",
          },
          {
            typeID: 16,
            name: "other",
          },
        ],
        relativeUserID: 135,
        relativeUserFname: "Sister",
        relativeUserLname: "Admin",
        relativeUserPhotoURL:
          "https://dhdj1c2suf90g.cloudfront.net/images/nophoto.jpg",
      },
    ],
  };

  return resp;
};

export default getHouseholdRelationships;
